import React from 'react';

class ProfilesPageMain extends React.Component {
  render(){
    return(
      <div>
        Profile page
      </div>
    );
  }
}

export default ProfilesPageMain
